import styled, { css } from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
export const iconSizes = {
    small: 10,
    large: 14,
};
export const buttonSizes = {
    small: 24,
    large: 24,
};
// The spec defines a 16px and 20px button box, but in order to make the target area
// a decent target size (24px) some padding and negative margin are used to keep
// the design correct.
// There's also some extra adjustments done to align the X with the text baseline.
const getButtonBox = (props) => {
    return css `
    margin: ${props.size === 'small' ? '-2px -5px' : '0 -2px'};
    padding: ${(buttonSizes[props.size] - iconSizes[props.size]) / 2}px;
  `;
};
export const StyledTag = styled.span `
  display: inline-grid;
  grid-column-gap: var(${(props) => props.theme.responsive.spacing.s});
  grid-template-columns: ${(props) => (props.removable ? 'auto 1fr' : 'auto')};

  background-color: ${(props) => props.theme.colors.utility.neutral[15]};

  ${(props) => injectSpacing('padding')({
    theme: props.theme,
    outerSpacing: ['xxs', 's', 'xxs', 's'],
})}
`;
export const StyledLabel = styled.span `
  color: ${(props) => props.theme.colors.text.secondary};

  ${(props) => injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1')}
`;
export const StyledButton = styled.button `
  display: inline-block;
  align-self: start;

  ${() => getButtonBox}

  color: ${(props) => props.theme.colors.utility.neutral[60]};
  &:hover {
    color: ${(props) => props.theme.colors.ui.hover};

    cursor: pointer;
  }

  background-color: transparent;
  border: none;

  appearance: none;
`;
export const StyledIcon = styled.svg `
  display: block;
`;
//# sourceMappingURL=Tag.styles.js.map